var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlooring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9665 39H10.0335C9.89198 39 9.75629 38.9438 9.65625 38.8438C9.5562 38.7437 9.5 38.608 9.5 38.4665V9.53346C9.5 9.39198 9.5562 9.25629 9.65625 9.15625C9.75629 9.0562 9.89198 9 10.0335 9H38.9665C39.108 9 39.2437 9.0562 39.3438 9.15625C39.4438 9.25629 39.5 9.39198 39.5 9.53346V38.4665C39.5 38.608 39.4438 38.7437 39.3438 38.8438C39.2437 38.9438 39.108 39 38.9665 39ZM31.9306 37.9331H38.4331V31.4306L32.4015 37.4621L32.3988 37.4649L32.396 37.4677L31.9306 37.9331ZM23.6265 37.9331H30.422L31.2674 37.0876L27.8697 33.6899L23.6265 37.9331ZM15.8736 37.9331H22.1177L31.3918 28.6589L28.2698 25.5369L18.4223 35.3844L15.8736 37.9331ZM10.5669 37.9331H14.3647L17.2907 35.0071L14.0127 31.7291L10.5669 35.1749V37.9331ZM28.624 32.9354L32.0217 36.3331L38.4331 29.9218V23.1265L32.5234 29.0362L28.624 32.9354ZM14.7672 30.9746L18.045 34.2526L34.4059 17.8917L31.1278 14.6137L24.7137 21.0281L24.7122 21.0294L14.7672 30.9746ZM10.5669 26.4995V33.6658L13.6299 30.6027L13.6352 30.5973L13.6405 30.592L23.5804 20.6519L20.0722 17.1436L10.5669 26.4995ZM29.0241 24.7824L32.1461 27.9044L38.4175 21.6332L38.4331 21.6181V15.3734L29.0241 24.7824ZM10.5669 17.7932V25.0024L14.7915 20.8441L11.1714 17.2239L10.5669 17.7932ZM11.9484 16.4919L15.552 20.0956L25.7049 10.1023H18.7321L11.9484 16.4919ZM20.8324 16.3951L24.3349 19.8976L34.1658 10.0669H27.2617L20.8324 16.3951ZM31.8822 13.8594L35.1602 17.1374L38.4331 13.8645V10.0669H35.6746L31.8822 13.8594ZM10.5669 10.0669V16.3276L10.7664 16.1399C10.7961 16.1042 10.83 16.0723 10.8674 16.0449L17.2134 10.0669H10.5669Z",
    fill: "url(#paint0_linear_2173_8463)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_8463",
    x1: 24.5,
    y1: 9,
    x2: 24.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlooring);
export default __webpack_public_path__ + "static/media/flooring.8105e35cd6bbe961f2b5f82b49888f48.svg";
export { ForwardRef as ReactComponent };